import { LIBIDA_PQP_PLAN_SELECTOR_VARIATION } from "~/constants/flags";

export const isLibidaPlanSelectorTreatment = (
    value: boolean | string | undefined
): boolean =>
    value === LIBIDA_PQP_PLAN_SELECTOR_VARIATION.TWO_MONTH_DEFAULT ||
    value === LIBIDA_PQP_PLAN_SELECTOR_VARIATION.THREE_MONTH_DEFAULT;
